import {
  LIFETIME_FOREVER_FLAG,
  LIFETIME_FOREVER_UNIT,
  type LIFETIME_UNITS,
} from '../components/form/endpoint/EndpointIdentityProviderForm.schema.ts';

export function convertHoursToFriendlyUnits(hours: null | number): [number | null, (typeof LIFETIME_UNITS)[number]] {
  if (hours === LIFETIME_FOREVER_FLAG) return [null, LIFETIME_FOREVER_UNIT];

  const days = hours / 24;
  const weeks = hours / (24 * 7);
  const months = hours / (24 * 30);

  if (hours <= 24) return [hours, 'Hours'];
  if (months === Math.floor(months)) return [months, 'Months'];
  if (weeks === Math.floor(weeks)) return [weeks, 'Weeks'];
  if (days === Math.floor(days)) return [days, 'Days'];
  return [hours, 'Hours'];
}

export function makeAuthValidityString(value: number | null, units: (typeof LIFETIME_UNITS)[number]) {
  if (units === LIFETIME_FOREVER_UNIT || value === null) return 'No expiration';
  switch (units) {
    case 'Hours':
      return value === 1 ? '1 hr' : `${value} hrs`;
    case 'Days':
      return value === 1 ? '1 day' : `${value} days`;
    case 'Weeks':
      return value === 1 ? '1 week' : `${value} weeks`;
    case 'Months':
      return value === 1 ? '1 month' : `${value} months`;
  }
}
